<template>
    <div>
        <div id="referenciaDesaparecen">
            <div id="referenciaDesaparecen1">
                <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickAlta()">Alta</b-button>
                <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickModificar()">Modificar</b-button>
                <b-button v-b-modal.modal-alta class="btn btn-success btn_desap" @click="clickEliminar()">Eliminar</b-button>
                <b-button v-b-modal.modal-buscar class="btn btn-success btn_desap" @click="">Buscar</b-button>
            </div>
        </div>

        <b-modal id="modal-alta" 
            header-bg-variant="success"
            size="xl"
            :title="titulo+' Bloque'">
            <div class="modal-body">

                <b-container class="">
                    <b-row>
                        <b-col sm="5" class="d-flex align-self-center">
                            <label class="pt-2">Detalle: </label> 
                            <b-form-input  
                                type="text" 
                                v-model="detalle" 
                                maxlength="60" 
                                :state="estadoDetalle" 
                                trim>
                            </b-form-input>
                        </b-col>
                        <b-col sm="2" class="d-flex align-self-center">
                            <b-form-checkbox v-model="activo" value="Si" unchecked-value="No" :state="estadoActivo" switch>Activo</b-form-checkbox>
                        </b-col>
                        <b-col sm="2" class="d-flex align-self-center">
                              <b-form-checkbox v-model="presentacion" value="Si" unchecked-value="No" :state="estadoPresentacion" switch>Presentación</b-form-checkbox>
                        </b-col>                   
                    </b-row>
                </b-container>               

            </div>
            <template v-slot:modal-footer="{ ok }" >
                <b-button id='Boton_Alta' :hidden="mostrarBotonAlta" variant="success" @click="altaBloques()">Guardar Bloque</b-button>
                <b-button id='Boton_Modificar' :hidden="mostrarBotonModificar" variant="success" @click="modificarBloques()">Guardar Bloque</b-button>
                <b-button id='Boton_Eliminar' :hidden="mostrarBotonEliminar" variant="danger" @click="eliminarBloques()">Eliminar Bloque</b-button>
                <b-button id="BotonOkAlta" variant="secondary" @click="ok()">Cancelar</b-button>

            </template>
        </b-modal>
             
         
            <b-table
                hover 
                small
                selectable
                sticky-header="500px"
                select-mode="single" 
                @row-selected="onRowSelected" 
                :fields="EncabezadoBloques"       
                :items="array_bloques">
            </b-table>

    </div>
</template>

<style>

</style>

<script>
  import { mapState, mapActions } from 'vuex';
  import { mapMutations } from 'vuex'

  export default {
    name: 'Home', 

    computed:{
        ...mapState(['host','array_bloques','array_usuario']),

        mostrarBotonAlta(){
          return this.titulo=='Alta de' ? false : true
        },
        mostrarBotonModificar(){
          return this.titulo=='Modificar' ? false : true
        },
        mostrarBotonEliminar(){
          return this.titulo=='Eliminar' ? false : true
        },
        bloquear_ME(){
          return this.id!=0 ? false : true
        },
        estadoDetalle(){
          return this.detalle=='' ? false : true
        },
        estadoActivo(){
          return this.activo=='' ? false : true
        },        
        estadoPresentacion(){
          return this.presentacion=='' ? false : true
        }
    },  
    methods:{
      ...mapActions(['CargarBloques']), 
      altaBloques: async function (){
          document.getElementById('BotonOkAlta').click();
          try{
              let newPost={
                  opcion:'Alta',
                  detalle:this.detalle,
                  activo:this.activo,
                  presentacion:this.presentacion,
                  session:this.array_usuario.session
              };
              const entradasBD = await fetch(this.host+'bloques.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              });
              this.CargarBloques(this.opciones);
          }catch (error){
              console.log(error);
          }  
      },
      modificarBloques: async function (){
          document.getElementById('BotonOkAlta').click();
          try{
              let newPost={
                  opcion:'Modificar',
                  id:this.id,
                  detalle:this.detalle,
                  activo:this.activo,
                  presentacion:this.presentacion,
                  session:this.array_usuario.session
              };
              const entradasBD = await fetch(this.host+'bloques.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              });
              this.CargarBloques(this.opciones);                           
          }catch (error){
              console.log(error);
          }  
      },
      eliminarBloques: async function (){
          document.getElementById('BotonOkAlta').click();
          try{
              let newPost={
                  opcion:'Eliminar',
                  id:this.id,
                  session:this.array_usuario.session
              };
              const entradasBD = await fetch(this.host+'bloques.php',{
                  method:'POST',
                  body: JSON.stringify(newPost),
                  headers:{
                    "Content-Type": "application/json"
                  }
              }); 
              this.CargarBloques(this.opciones);                          
          }catch (error){
              console.log(error);
          }  
      },
      clickAlta() {
          this.titulo='Alta de';
          this.id=0;
          this.detalle='';
          this.activo='';
          this.presentacion='';
      },
      clickModificar() {
          this.titulo='Modificar';
      },
      clickEliminar() {
          this.titulo='Eliminar';
      },        
      onRowSelected(items) {
          if (items.length==1){
              this.id=items[0]['id'];
              this.detalle=items[0]['detalle'];
              this.activo=items[0]['activo'];
              this.presentacion=items[0]['presentacion'];
          }
      },

    },

    data() {
      return {
          titulo:'',
          id:0,
          detalle:'',
          activo:'',
          presentacion:'',
          EncabezadoBloques: [         
            {
              key: 'detalle',
              label: 'Detalle',
              sortable: true
            },
            {
              key: 'activo',
              label: 'Activo',
            },
            {
              key: 'presentacion',
              label: 'Presentación',
              sortable: true
            }
          ],
          opciones:{presentacion:'No', eliminado:'No', seleccion:'No'}, 
      }
    },   
    created(){
        this.CargarBloques(this.opciones);
    }
  }
</script>
